/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Header_SubtitleInputs */

const es_admin_header_subtitle = /** @type {(inputs: Admin_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión general y de usuarios de Nexata`)
};

const en_admin_header_subtitle = /** @type {(inputs: Admin_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General and user management for Nexata`)
};

/**
* | output |
* | --- |
* | "General and user management for Nexata" |
*
* @param {Admin_Header_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_header_subtitle = /** @type {((inputs?: Admin_Header_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Header_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_header_subtitle(inputs)
	return en_admin_header_subtitle(inputs)
});
export { admin_header_subtitle as "admin.header.subtitle" }